import { CorrectionRequestApi } from "./CorrectionRequestApi";
import { AppUtils } from '../../../../../shared/utils/index';

export class PriceCorrectionRequestApi extends CorrectionRequestApi {

	constructor(initialProperties?: Partial<PriceCorrectionRequestApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	private preisSuperE10: number;
	public get PreisSuperE10(): number {
		return this.preisSuperE10;
	}
	public set PreisSuperE10(value: number) {
		this.preisSuperE10 = value;
	}

	private preisSuper: number;
	public get PreisSuper(): number {
		return this.preisSuper;
	}
	public set PreisSuper(value: number) {
		this.preisSuper = value;
	}

	private preisDiesel: number;
	public get PreisDiesel(): number {
		return this.preisDiesel;
	}
	public set PreisDiesel(value: number) {
		this.preisDiesel = value;
	}

	public static createFromObject(dataObject: { [key: string]: any }): PriceCorrectionRequestApi {
		return AppUtils.Helper.createFromMap(dataObject, PriceCorrectionRequestApi);
	}

	public toRequestObject(): { [key: string]: any } {
		const result = super.toRequestObject();
		result.PreisSuperE10 = this.PreisSuperE10;
		result.PreisSuper = this.PreisSuper;
		result.PreisDiesel = this.PreisDiesel;
		return result;
	}
}